import { useRef, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { api, json, ApiError } from "../../api";
import { commandIdentity, commandAccepted } from "../data/command";
import { pendingRequest, retainRequest, clearRequest, responseUncertain } from "./request";
/** Content endpoints accept request_id only, unlike accounting endpoints. */
export function useContentCommand(scope: string) {
  const [busy,setBusy]=useState(false),[error,setError]=useState(""),[uncertain,setUncertain]=useState(!!pendingRequest(scope));
  const lock=useRef(false);
  const cache=useQueryClient();
  const execute=async <T,>(path?:string,payload?:Record<string,unknown>):Promise<T>=>{
    if(lock.current)throw Error("Дождитесь ответа на предыдущий запрос.");
    let request=pendingRequest(scope);
    if(request&&path)throw Error("Сначала проверьте результат предыдущего действия.");
    if(!request){
      if(!path||!payload)throw Error("Нет запроса для проверки.");
      const identity=commandIdentity(path,payload);
      request={path,init:json({...payload,request_id:identity.id}),fingerprint:identity.fingerprint};
      retainRequest(scope,request);
    }
    lock.current=true;setBusy(true);setError("");
    try{
      const value=await api<T>(request.path,request.init);
      commandAccepted(request.fingerprint);clearRequest(scope);setUncertain(false);return value;
    }catch(e){
      const unknown=responseUncertain(e);setUncertain(unknown);
      if(!unknown){commandAccepted(request.fingerprint);clearRequest(scope);}
      setError(e instanceof Error?e.message:"Не удалось выполнить действие");
      if(e instanceof ApiError&&e.status===409)await cache.invalidateQueries({queryKey:["content-detail"]}).catch(()=>undefined);
      throw e;
    }finally{lock.current=false;setBusy(false);}
  };
  return {command:execute,retry:<T,>()=>execute<T>(),busy,error,uncertain};
}
